import Dropdown from './Dropdown';
export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ../~/rc-dropdown/es/index.js
// module id = 1945
// module chunks = 1